import { all, call, put, takeLatest } from 'redux-saga/effects'
import co from 'co'
import { trackHelpCenterTicketCreated } from 'middleware/helper'
import { isEmpty } from 'utils/appUtils'
import { actions, postCommentsSuccess, postCommentsFailure } from './actions'
import { postCommentURL, downloadSmsURL } from './urls'
import { api } from '../../network/api'
//= ============================================================================================================

function* sendComments(action) {
    const request = action.payload
    try {
        yield call(api, postCommentURL, 'POST', request)
        yield put(postCommentsSuccess())
        if (isEmpty(action.orderDetails)) {
            trackHelpCenterTicketCreated({ order_id: null, order_status: null })
        } else {
            trackHelpCenterTicketCreated(action.orderDetails)
        }
    } catch (error) {
        yield put(postCommentsFailure(error))
    }
}

//= ============================================================================================================
export const sendPhoneNumber = co.wrap(function* (phoneNumber) {
    const request = {
        mobileNumbers: [`1${phoneNumber}`],
        // shortCode: '711711',
        // messageText: 'GENTEST',
    }
    try {
        const response = yield api(downloadSmsURL, 'POST', request)
        return yield response
    } catch (err) {
        return yield err
    }
})

function* postCommentsWatcher() {
    yield takeLatest(actions.POST_COMMENTS, sendComments)
}

export default function* contactUs() {
    yield all([postCommentsWatcher()])
}
